import { DisabilityProduct } from "./DisabilityProduct";

export enum FederationProduct {
    ACCIDENT = 'accident',
    CRITICAL_ILLNESS = 'criticalIllness',
    GROUP_TERM_LIFE = 'groupTermLife',
    HOSPITAL_INDEMNITY_CHOICE = 'hospitalIndemnityChoice',
    LONG_TERM_DISABILITY = 'longTermDisability',
    SHORT_TERM_DISABILITY = 'shortTermDisability',
    VOLUNTARY_TERM_LIFE = 'voluntaryTermLife',
    PAID_FAMILY_LEAVE = 'paidFamilyLeave',
    PAID_MEDICAL_LEAVE = 'paidMedicalLeave'
}

export function findProductFor(disabilityProduct: DisabilityProduct): FederationProduct | null {
    if(disabilityProduct === DisabilityProduct.SHORT_TERM_DISABILITY) {
        return FederationProduct.SHORT_TERM_DISABILITY;
    } else if(disabilityProduct === DisabilityProduct.LONG_TERM_DISABILITY) {
        return FederationProduct.LONG_TERM_DISABILITY;
    }
    return null;
}
